import { DatePipe } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { FormControl } from '@angular/forms';
import { BookingConfigService } from '../services/booking-config.service';

@Component({
  selector: 'app-itinerary',
  templateUrl: './itinerary.component.html',
  styleUrl: './itinerary.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ItineraryComponent {
  site: string = '';
  activeTab: string = "book";

  arrivalFlight: any;
  departureFlight: any;

  arrivalFlightDate: any;
  departureFlightDate: any;

  hotelArrivalDatetime: any;
  hotelDepartureDatetime: any;

  parkingArrivalTime: any;
  parkingDepartureTime: any;

  arrivalHotel: any;
  departureHotel: any;

  isArrivalHotel: any;
  isDepartureHotel: any;

  parkingStartTime: any;
  parkingEndTime: any;

  selectType: string = '';
  private _organization: string = '';
  discountCodeControl = new FormControl('');
  flightTimeWarning = false;

  @Input() organizationId: string = '';

  constructor(
    private router: Router,
    private _formService: FormService,
    private _datePipe: DatePipe,
    private route: ActivatedRoute,
    private bookingConfigService: BookingConfigService
  ) {
    // const config = this.bookingConfigService.getConfig();
    // this.site = config.site;
  }

  ngOnInit(): void {
    const orgId = this.organizationId?.toUpperCase();
    switch (orgId) {
      case 'A848CCD3-FD8D-4035-925E-571EBB4E93E8': this.site = "flygets";
        break;
      case '2868EF69-054C-40BD-93AE-85CF08E4C71F': this.site = "tui";
        break;
      case '3868EF69-054C-40BD-93AE-85CF08E4C71F': this.site = "nazar";
        break;
      default: this.site = this.bookingConfigService.getConfig().site;
        break;
    }
    this._formService.initForm(this.site);

    this.route.paramMap.subscribe(params => {
      this._organization = params.get('organization') || "";
    });

    const search = this._formService.getForm().get('search');
    const flights = this._formService.getForm().get('flights');
    const hotels = this._formService.getForm().get('hotels');

    flights.controls.arrivalFlight.valueChanges.subscribe((value: any) => {
      this.arrivalFlight = value;
    });
    flights.controls.departureFlight.valueChanges.subscribe((value: any) => {
      this.departureFlight = value;
    });

    search.controls.arrivalFlightDate.valueChanges.subscribe((value: any) => {
      this.arrivalFlightDate = value;
    });
    search.controls.departureFlightDate.valueChanges.subscribe((value: any) => {
      this.departureFlightDate = value;
    });

    search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.parkingDepartureTime = value;
    });
    search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.parkingArrivalTime = value;
    });

    hotels.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.hotelArrivalDatetime = value;

    });
    hotels.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.hotelDepartureDatetime = value;
    });

    hotels.controls.arrivalHotel.valueChanges.subscribe((value: any) => {
      this.arrivalHotel = value;
    });
    hotels.controls.departureHotel.valueChanges.subscribe((value: any) => {
      this.departureHotel = value;
    });

    search.controls.isArrivalHotel.valueChanges.subscribe((value: any) => {
      this.isArrivalHotel = value;
    });
    search.controls.isDepartureHotel.valueChanges.subscribe((value: any) => {
      this.isDepartureHotel = value;
    });
  }

  get isContinueButtonEnabled(): boolean {
    let isArrivalComplete = false;
    let isDepartureComplete = false;

    if (this.isArrivalHotel) {
      isArrivalComplete = this.arrivalHotel && this.hotelArrivalDatetime;
    } else {
      isArrivalComplete = this.arrivalFlight && this.parkingDepartureTime;
    }

    if (this.isDepartureHotel) {
      isDepartureComplete = this.departureHotel && this.hotelDepartureDatetime;
    } else {
      isDepartureComplete = this.departureFlight && this.parkingArrivalTime;
    }

    if (this.arrivalFlight && this.departureFlight) {

      const depTime = new Date(this.departureFlight?.departureTime?.scheduled)?.getTime();
      const arrTime = new Date(this.arrivalFlight?.arrivalTime?.scheduled)?.getTime();

      if (arrTime < depTime) {
        this.flightTimeWarning = true;
      } else {
        this.flightTimeWarning = false;
      }
    }

    return isArrivalComplete && isDepartureComplete && this.flightTimeWarning == false;
  }

  goToBookingForm() {

    const hotels = this._formService.getForm().get('hotels');
    const flights = this._formService.getForm().get('flights');
    const search = this._formService.getForm().get('search');


    let parking_start = this._formService.searchStartDate;
    let parking_end = this._formService.searchEndDate;


    let arrival_flight = this._formService.selectedArrivalFlight;
    let departure_flight = this._formService.selectedDepartureFlight.getValue();

    parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
    parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');

    if (this._formService.getForm().get('search').controls.isArrivalHotel.value) {
      parking_end = this._formService.getForm().get('hotels').controls.arrivalDatetime.value;
      parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');
      arrival_flight = null;
    } else {
      hotels.controls.arrivalDatetime = null;
      hotels.controls.arrivalHotel = null;
      this._formService.arrivalHotel = null;
    }
    if (this._formService.getForm().get('search').controls.isDepartureHotel.value) {
      parking_start = this._formService.getForm().get('hotels').controls.departureDatetime.value;
      parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
      departure_flight = null;
    } else {
      hotels.controls.departureDatetime = null;
      hotels.controls.departureHotel = null;
      this._formService.departureHotel = null;

    }
    let departure_hotel = this._formService.departureHotel || null;
    let arrival_hotel = this._formService.arrivalHotel || null;

    let searchData = {
      //arrival
      arrivalFlightDate: search.controls.arrivalFlightDate?.value,
      arrivalFlight: flights.controls.arrivalFlight?.value,
      arrivalDatetime: search.controls.arrivalDatetime?.value,

      arrivalHotel: hotels.controls.arrivalHotel?.value,
      hotelArrivalDate: hotels.controls.arrivalDatetime?.value,
      hotelArrivalDatetime: hotels.controls.arrivalDatetime?.value,


      //departure
      hotelDepartureDate: hotels.controls.departureDatetime?.value,
      departureHotel: hotels.controls.departureHotel?.value,
      hotelDepartureDatetime: hotels.controls.departureDatetime?.value,



      departureFlight: flights.controls.departureFlight?.value,
      departureFlightDate: search.controls.departureFlightDate?.value,
      departureDatetime: search.controls.departureDatetime?.value,
    }
    let queryParams: any = {
      parking_start: parking_start || undefined,
      parking_end: parking_end || undefined,

    };

    switch (this.site) {
      case 'flygets':
        queryParams['discount_code'] = this.discountCodeControl.value.length > 0 ? this.discountCodeControl.value : 'NONE';
        break;
      case 'tui':
        queryParams['discountCode'] = 'TUI10';
        break;
      case 'nazar':
        queryParams['discountCode'] = 'nazar';
        break;
    }

    this.router.navigate(['parkifly', this.site, 'booking', queryParams],
      {
        state: {
          arrival_flight,
          departure_flight,
          departure_hotel,
          arrival_hotel,
          searchData,
          org: this._organization || this.site
        }
      }
    );
  }

}
